module.exports = __webpack_public_path__ + "img/icon_xuexixiaoli.d2f22772.png";